<template>
  <div class="text-center text-lg font-bold">Conversas</div>
  <text-input v-model="search" class="my-3 w-full" placeholder="pesquisar" />
  <div class="flex flex-wrap cursor-pointer border-b p-2 hover:bg-gray-200" v-if="roomsList.length" @click.prevent="openChat(item)" v-for="(item, index) in roomsList">
    <div class="w-2/3 overflow-x-hidden">{{ item.name }}</div>
    <div class="w-1/3 text-xs items-center" :class="{grid: item.unreadMessages(), 'grid-cols-2': item.unreadMessages()}">
      <span class="flex h-4 w-4" v-if="item.unreadMessages()">
        <span class="animate-ping absolute inline-flex h-4 w-4 rounded-full bg-blue-400 opacity-75"></span>
        <span class="relative rounded-full h-4 w-4 bg-blue-600 text-white text-center" style="font-size: 0.6rem">{{ item.unreadMessages().length }}</span>
      </span>
      <div class="flex justify-end">{{ showDate(item.updatedAt) }}</div>
    </div>
    <div class="w-full text-xs">{{ item.lastMessage }}</div>
  </div>
  <div v-else>Nenhuma conversa encontrada</div>
</template>
<script>
//import fire from "./fire";
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    TextInput,
  },
  props: {
    users: {
      type: Array,
      default: [],
    },
    rooms: {
      type: Array,
      default: [],
    },
  },
  computed: {
    roomsList: function () {
      return this.rooms.filter((item) => !this.search.length || item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0);
    },
    searching: function () {
      return this.search.length ? true : false;
    },
  },
  data() {
    return {
      search: '',
      loading: true,
    };
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  methods: {
    /*loadUserRooms(userRooms) {
      this.rooms = [];
      userRooms.forEach((_userRoom) => {
        let userRoomKey = _userRoom.key;
        fire.database().ref('rooms/' + userRoomKey).on('value', this.loadRoom);
      });
    },
    loadRoom(_room) {
      let room = _room.val();

      this.rooms = this.rooms.filter((val) => val.id != _room.key);

      let others = Object.keys(Object.fromEntries(Object.entries(room.users).filter(([key]) => key != usePage().props.value.auth.user.id)));
      let othersNames = this.users.filter((val) => others.indexOf(val.id) >= 0).map((val) => val.name);

      this.rooms.push({
        id: _room.key,
        name: othersNames.join(', '),
        others: others,
        othersNames: othersNames,
        lastMessage: room.lastMessage,
        users: room.users,
        updatedAt: room.updatedAt,
        createdAt: room.createdAt,
      });
    },*/
    openChat(item) {
      this.$parent.openRoom(item);
    },
    showDate(_date) {
      let today = parseInt(this.$filters.formatDateTime(new Date(), 'yyyyMMdd'));
      let date = parseInt(this.$filters.formatDateTime(_date, 'yyyyMMdd'));
      if(today == date) {
        return this.$filters.formatDateTime(_date, 'HH:mm');
      } else if(today == (date + 1)) {
        return 'Ontem';
      } else {
        return this.$filters.formatDate(_date);
      }
    },
  },
  /*mounted() {
    fire.database().ref('user_rooms/' + this.user.id).on("value", this.loadUserRooms);
  },
  unmounted() {
    fire.database().ref('user_rooms/' + this.user.id).off("value", this.loadUserRooms);
  }*/
}
</script>